
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getCurrentGroup } from '@/router';

@Component({})
export default class TopBarNavItem extends Vue {
  @Prop(String) readonly path!: string;
  @Prop(String) readonly title!: string;
  @Prop(Number) readonly index!: number;
  @Prop({ default: false }) readonly activeBar?: boolean;

  active = false;

  onClick(event: PointerEvent) {
    event.preventDefault();

    this.$emit('route-clicked');

    this.$ga.event({
      eventCategory: 'topbar-nav',
      eventAction: 'click',
      eventLabel: this.title
    });

    if (this.path) {
      this.$router.push(this.path);
    }
  }

  @Watch('$route')
  onRouteChange() {
    const group = getCurrentGroup();
    this.active = group && group.path === this.path;
  }

  mounted() {
    const group = getCurrentGroup();
    this.active = group && group.path === this.path;
  }
}
